import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnnotationService } from '../../../annotations/core/annotation.service';
import { FlagService } from '../../../core/flag.service';
import { FileUtilsService } from '../../file/core/file-utils.service';
import { FileService } from '../../file/core/file.service';
import { RlFile } from '../../file/shared/rl-file';
import { EmbeddedMode } from '../../shared/shared/embeded-mode.enum';
import { CitationAvailabilityService } from '../core/citation-availability.service';
import { UtilsService } from '../../shared/core/utils.service';
import { CitationAvailability } from '../shared/citation-availability';
import { AuthService, ContainerService, ShoppingCartService } from '../../../ajs-upgraded-providers';
import { Console } from 'console';

@Component({
  selector: 'rl-content-access',
  templateUrl: './content-access.component.html',
  styleUrls: ['./content-access.component.scss', './content-access.component-rtl.css']
})
export class ContentAccessComponent implements OnInit {
  @Input() content: RlFile;
  @Input() citAvail: CitationAvailability;
  @Input() hidden: boolean;
  @Input() type: string;
  @Input() studentView?: boolean;
  @Input() hasBrowzineLink?: boolean;
  @Input() displayDisclaimer?: boolean;
  @Output() clickAction: EventEmitter<string> = new EventEmitter<string>();

  actions: string[];

  isPdf: boolean;
  pdfReadOnly: boolean;
  student: boolean;
  hierarchy: string;
  librarian: string;
  showViewerLink: boolean;
  hideMenu: boolean;
  enablePayPerUse: boolean;
  showAnnotations: boolean = true;

  constructor(
    private flagService: FlagService,
    private authService: AuthService,
    private annotationService: AnnotationService,
    private fileUtils: FileUtilsService,
    private availabilityService: CitationAvailabilityService,
    private fileService: FileService,
    private utils: UtilsService,
    private shoppingCartService: ShoppingCartService,
    private containerService: ContainerService
  ) {}

  ngOnInit(): void {
    this.student = this.authService.isStudent();
    this.initActions();
    this.showAnnotations = !this.utils.isTouchScreen();
    //!("false" == (new URLSearchParams(document.location.search)).get("annotations_support"));
  }

  initActions() {
    this.librarian = this.authService.isLibrarianOrAdmin() || this.authService.isCourseOperator();
    this.enablePayPerUse = this.flagService.isEnablePayPerUse();

    this.isPdf = this.fileUtils.isPDF(this.content.amazonDisplayFileName) || this.content.url != undefined;
    this.pdfReadOnly = ((this.citAvail && this.citAvail.embedded == EmbeddedMode.READONLY) || this.flagService.isLegantoViewerReadOnly()) && this.isPdf;
    let showViewerActions = this.isPdf && (this.flagService.isLegantoViewerActive() || this.flagService.isLegantoViewerReadOnly()) && !this.student && !this.studentView;
    this.showViewerLink = (this.flagService.isLegantoViewerActive() || this.pdfReadOnly) && this.type != 'collection';

    //guest will not have menu
    this.hideMenu = this.type == 'collection' || !this.content || this.authService.isGuest() || ((this.student || this.studentView) && this.showAddToCart());
    this.actions = [];
    if (this.hideMenu) {
      return;
    }

    if (!this.content.itemLocked && !this.student && showViewerActions && !this.flagService.isLegantoViewerReadOnly()) {
      this.actions.push(this.pdfReadOnly ? 'makeFileDownloadable' : 'makeFileReadOnly');
    }

    if (!this.content.itemLocked && !this.student && !this.studentView && this.flagService.isInstructorCanManageCitationAvailability()) {
      this.hidden = this.citAvail && this.citAvail.hidden;
      this.actions.push(this.hidden ? 'showContentToggel' : 'hideContentToggel');
    }

    if (this.librarian || this.flagService.showMarkAsBrokenAll()) {
      this.actions.push('markAsBrokenClicked');
    }
  }

  onChangeAnnotationToggle(e: string) {
    this.content.allowAnnotations = !this.content.allowAnnotations;
    this.annotationService.enablePublicAnnotations(this.content.entityId as any, this.content.allowAnnotations).subscribe(() => this.clickAction.emit('onChangeAnnotationToggle'));
  }

  displayAnnottaionToggel() {
    return this.showAnnotations && this.flagService.isDisplayAnnottaionToggel() && (this.fileUtils.isPDF(this.content.amazonFileKey) || this.content.url != undefined);
  }

  makeFileReadOnly() {
    this.availabilityService.makeFileReadOnly(this.citAvail).subscribe((ca) => this.initActions());
    this.clickAction.emit('makeFileReadOnly');
  }

  makeFileDownloadable() {
    this.availabilityService.makeFileDownloadable(this.citAvail).subscribe((ca) => this.initActions());
    this.clickAction.emit('makeFileDownloadable');
  }

  hideContentToggel() {
    this.toggelClicked();
  }

  showContentToggel() {
    this.toggelClicked();
  }

  clickMenu(e: string) {
    this[e]();
  }

  toggelClicked() {
    this.availabilityService.toggelVisibility(this.citAvail).subscribe((ca) => {
      this.initActions();
      this.clickAction.emit('toggelClicked');
    });
  }

  markAsBrokenClicked(e: string) {
    this.clickAction.emit('markAsBrokenClicked');
  }

  download() {
    if (this.displayDisclaimer) {
      this.clickAction.emit('openConfirmDialogDownload');
    } else {
      this.fileService.download(this.content);
    }
  }

  openInNewTab(): void {
    if (this.displayDisclaimer) {
      this.clickAction.emit('openConfirmDialogViewer');
    } else {
      this.utils.openViewerInNewTab(this.content);
    }
  }

  showDownload() {
    if (this.utils.isTouchScreen() && 'true' == new URLSearchParams(document.location.search).get('campusm')) {
      return false;
    }

    if (this.pdfReadOnly) {
      return false;
    }
    if (!this.student && !this.studentView) {
      return true;
    }
    if ((this.student || this.studentView) && this.showAddToCart()) {
      return false;
    }

    return true;
    //<!-- ng-if="!isStudentView() || (isStudentView() && ((item.licenseFunded && item.licenseType=='CCC' && item.licenseStatus && myuser.enablePayPerUse) || (item.licenseType!='CCC' || !myuser.enablePayPerUse)))"> -->
    //librarian && !studentView  || (((!student && studentView) || student) && !(enablePayPerUse && student && showAddToCart()) ) && !pdfReadOnly
  }

  showContentPreview() {
    if (!this.content) {
      return false;
    }
    if (!this.isPdf) {
      //|| this.flagService.isLegantoViewerInActive()){
      return false;
    }
    if (!this.student && !this.studentView) {
      return true;
    }
    if ((this.student || this.studentView) && this.showAddToCart()) {
      return false;
    }
    return true;
  }

  showStudentInstPays() {
    return this.content && this.content.license && this.content.license.type == 'CCC' && this.content.license.status && this.enablePayPerUse && !this.studentView && !this.student;
  }
  showAddToCart() {
    return this.content && this.content.license && this.content.license.type == 'CCC' && !this.content.license.funded && !this.content.license.usedForUser;
  }

  isItemInCart() {
    return this.shoppingCartService.findItem(this.content.entityId) != undefined;
  }

  manageCart() {
    this.clickAction.emit('manageCart');
  }

  openShoppingCart() {
    this.containerService.put('showShoppingCart', true);
  }
}
